import { EmptyState as MantineEmptyState } from '@mantine/core'
import type { ReactNode } from 'react'

/**
 * Nothing to show yet (UX spec §4.5): a one-line title, one sentence and at least one action that fixes it, so an
 * empty page is never a dead end. By default the icon sits on the wave illustration (identity.md §7: two layered
 * waves in the illustration tokens, light and dark); [art] "icon" puts it in a soft teal circle instead, for spaces
 * too small for the waves.
 */
export function EmptyState(props: {
  icon: ReactNode
  title: string
  body: ReactNode
  action: ReactNode
  art?: 'wave' | 'icon'
}) {
  const art =
    props.art === 'icon' ? (
      <span className="empty-state-icon">{props.icon}</span>
    ) : (
      <span className="empty-state-waves">
        <svg viewBox="0 0 300 120" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,70 C50,50 90,90 150,70 S250,45 300,62 V120 H0Z" className="empty-state-wave-back" />
          <path d="M0,88 C60,70 100,104 160,88 S260,72 300,84 V120 H0Z" className="empty-state-wave-front" />
        </svg>
        <span className="empty-state-waves-icon">{props.icon}</span>
      </span>
    )
  return (
    <MantineEmptyState
      icon={art}
      title={props.title}
      description={props.body}
      py="xl"
      px="md"
      styles={{ title: { fontWeight: 600 } }}
    >
      <MantineEmptyState.Actions>{props.action}</MantineEmptyState.Actions>
    </MantineEmptyState>
  )
}
